import { skipToken } from '@tanstack/react-query';
import { useMemo } from 'react';
import { trpc } from '../../utils/trpc/trpc.ts';
import { EquipmentOption, SelectedPart } from './types.ts';


/**
 * Load batch history for the selected equipment or part.
 */
export function useFetchBatches(
    selectedEquipment: EquipmentOption | null,
    selectedPart: SelectedPart | null,
) {
    const selection = selectedEquipment ? { equipment: selectedEquipment.id }
        : selectedPart?.partName ? { partName: selectedPart.partName }
            : selectedPart?.product ? { product: selectedPart.product }
                : null;

    const batchesQuery = trpc.batches.getInfinite.useInfiniteQuery(
        selection ? {
            ...selection,
            limit: 10,
        } : skipToken,
        {
            getNextPageParam: (last) => last.nextCursor,
            refetchInterval: 10 * 60_000,
        }
    );

    // Keep the list stable between query updates to avoid resetting selection and KPI requests.
    const batches = useMemo(
        () => batchesQuery.data?.pages.flatMap(page => page.batches),
        [batchesQuery.data],
    );

    return {
        batches,
        hasMore: batchesQuery.hasNextPage,
        loadMore: () => batchesQuery.fetchNextPage(),
        isLoadingBatches: batchesQuery.isLoading || batchesQuery.isFetchingNextPage,
    };
}
